import React from 'react';
import { classNames } from '../../utils/formatters';

// Compound sub-components for Modal. Used as <Modal.Header> etc. when the default
// header/footer rendering isn't enough and a screen needs full control of the slots.

export function ModalHeader({ children, className }) {
  return (
    <div className={classNames('px-6 py-4 border-b border-gray-200', className)}>
      {children}
    </div>
  );
}

export function ModalBody({ children, className }) {
  return (
    <div className={classNames('px-6 py-5 overflow-y-auto custom-scrollbar', className)}>
      {children}
    </div>
  );
}

export function ModalFooter({ children, className }) {
  return (
    <div
      className={classNames(
        'px-6 py-4 border-t border-gray-200 bg-gray-50 flex flex-wrap gap-3 justify-end',
        className,
      )}
    >
      {children}
    </div>
  );
}
